import { type IDemo, RecordingTypes } from '@carboncopyco/types';
import {
  type TabGroup,
  TabGroupName,
  TabType,
} from '@carboncopyco/types/desktop';
import { settings } from '../../../../settings';
import { generateGroupId } from '../../../util/tab-util';
import useOpenDemoTab from './openDemoTab';

export const useOpenDemoEditorTab = () => {
  const openDemoEditorTab = useOpenDemoTab();

  return (demo: IDemo, activeOrganizationId: number, firstUrl?: string) => {
    const groupId = generateGroupId(Number(demo.id), TabGroupName.DemoEditor);

    const groupOptions: TabGroup = {
      id: groupId,
      name: TabGroupName.DemoEditor,
      isVisibleIfGroupIsActive: true,
      isVisibleIfGroupIsInactive: true,
      showNonRelatedGroupTabsIfActive: true,
      focusOnCreate: true,
      closeGroupOnClose: true,
      mergingOptions: {
        allowed: true,
        key: demo.id,
        isDetached: false,
        index: 0,
        detachedTitle: demo.demoName,
      },
    };

    if (demo.recordingType !== RecordingTypes.overlay) {
      openDemoEditorTab(demo, {
        tabTitle: demo.demoName,
        tabType: TabType.DEMO_EDITOR,
        firstUrl,
        group: groupOptions,
      });
      return;
    }
    if (demo.recordingType === RecordingTypes.overlay) {
      openDemoEditorTab(demo, {
        tabTitle: demo.demoName,
        tabType: TabType.OVERLAY_EDITOR,
        firstUrl,
        group: groupOptions,
      });
      return;
    }
    const webUrl = `${settings.WEB_APP}/${activeOrganizationId}/workspace/${demo.workspaceId}/demo/${demo.id}/dynamic-editor`;
    window.dsDesktop.shellOpenExternal(webUrl);
  };
};
